// Auto-generated by extract-doctors.cjs
import { abdykhadirov } from './abdykhadirov';
import { nurgalieva } from './nurgalieva';
import { nugmetollanova } from './nugmetollanova';
import { toygulova } from './toygulova';
import { akhmetova } from './akhmetova';
import { erbolatova } from './erbolatova';
import { kozhakhmetova } from './kozhakhmetova';
import { boltaev } from './boltaev';
import { tynyshtykova } from './tynyshtykova';
import { kokymbaeva } from './kokymbaeva';
import { fayzolda } from './fayzolda';
import { nartbaev } from './nartbaev';
import { utesheva } from './utesheva';
import { makenqyzy } from './makenqyzy';
import { asiya } from './asiya';
import { anes } from './anes';
import { kolkhozov } from './kolkhozov';
import { nigmetova } from './nigmetova';
import { burambaeva } from './burambaeva';
import { zhaparova } from './zhaparova';
import { dosmuratov } from './dosmuratov';
import { gulzhaina } from './gulzhaina';
import { nurzhauova } from './nurzhauova';
import { abaeva } from './abaeva';
import { zhanuzakova } from './zhanuzakova';
import { sovetov } from './sovetov';
import { saitgaraev } from './saitgaraev';

export const doctors = [
  abdykhadirov,
  nurgalieva,
  nugmetollanova,
  toygulova,
  akhmetova,
  erbolatova,
  kozhakhmetova,
  boltaev,
  tynyshtykova,
  kokymbaeva,
  fayzolda,
  nartbaev,
  utesheva,
  makenqyzy,
  asiya,
  anes,
  kolkhozov,
  nigmetova,
  burambaeva,
  zhaparova,
  dosmuratov,
  gulzhaina,
  nurzhauova,
  abaeva,
  zhanuzakova,
  sovetov,
  saitgaraev
];

export {
  abdykhadirov,
  nurgalieva,
  nugmetollanova,
  toygulova,
  akhmetova,
  erbolatova,
  kozhakhmetova,
  boltaev,
  tynyshtykova,
  kokymbaeva,
  fayzolda,
  nartbaev,
  utesheva,
  makenqyzy,
  asiya,
  anes,
  kolkhozov,
  nigmetova,
  burambaeva,
  zhaparova,
  dosmuratov,
  gulzhaina,
  nurzhauova,
  abaeva,
  zhanuzakova,
  sovetov,
  saitgaraev
};
